export type DesktopLayout = { sidebarWidth: number; listWidth: number; sidebarVisible: boolean };
export const defaultDesktopLayout: DesktopLayout = {
  sidebarWidth: 220,
  listWidth: 480,
  sidebarVisible: true,
};
export function clampDesktopWidth(kind: 'sidebar' | 'list', value: number, maximum = Infinity) {
  return Math.round(
    Math.max(kind === 'sidebar' ? 190 : 300, Math.min(kind === 'sidebar' ? 300 : maximum, value)),
  );
}
export function parseDesktopLayout(value: unknown): DesktopLayout {
  if (!value || typeof value !== 'object') return { ...defaultDesktopLayout };
  const input = value as Partial<DesktopLayout>;
  return {
    sidebarWidth: Number.isFinite(input.sidebarWidth)
      ? clampDesktopWidth('sidebar', input.sidebarWidth!)
      : 220,
    listWidth: Number.isFinite(input.listWidth) ? clampDesktopWidth('list', input.listWidth!) : 480,
    sidebarVisible: typeof input.sidebarVisible === 'boolean' ? input.sidebarVisible : true,
  };
}
export function desktopLayoutKey(origin: string, user: string) {
  return `kiipu.desktop.workspace.v1:${JSON.stringify([origin, user])}`;
}
export function readDesktopLayout(key: string): DesktopLayout {
  try {
    const saved = localStorage.getItem(key);
    if (saved) return parseDesktopLayout(JSON.parse(saved));
    return parseDesktopLayout({
      listWidth: Number(localStorage.getItem('kiipu.list-width.v1')) || 480,
    });
  } catch {
    return { ...defaultDesktopLayout };
  }
}
